module.exports = __webpack_public_path__ + "media/images/icons/chevron-bottom-8dea4467643c84eb3d81e9eb26f211a2.svg";